import { render, staticRenderFns } from "./cartList.vue?vue&type=template&id=71936cf9&scoped=true"
import script from "./cartList.vue?vue&type=script&lang=js"
export * from "./cartList.vue?vue&type=script&lang=js"
import style0 from "./cartList.vue?vue&type=style&index=0&id=71936cf9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71936cf9",
  null
  
)

export default component.exports